import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SthanComponent } from './sthan.component';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '../accordion/accordion.module';
import { ImagegridModule } from "../imagegrid/imagegrid.module";
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';



@NgModule({
    declarations: [
        SthanComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        AccordionModule,
        ImagegridModule,
        GoogleMapsModule
    ]
})
export class SthanModule { }
